<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>HD{{ pad(item.id,6) }}</td>
                            <td>{{ item.created_at | display_date }}</td>
                            <td>{{ item.customer_first_name }} {{ item.customer_last_name }}</td>
                            <td class="text-right">{{ item.number_of_product | currency }}</td>
                            <td class="text-right">{{ item.total | currency }}</td>
                            <td class="text-right">{{ item.discount | currency }}</td>
                            <td class="text-right">{{ item.amount | currency }}</td>
                            <td class="text-right">{{ item.paid | currency }}</td>
                            <td>{{ item.note }}</td>
                            <td>{{ item.created_by }}</td>
                            <td class="text-center" v-if="!customer_id">         
                                <v-icon medium class="mr-2" @click="editItem(item.id)">edit</v-icon>
                                <v-icon medium @click="deleteItem(item.id)" v-if="adminRole">delete</v-icon>
                            </td>
                            <td v-else></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { sendSuccessNotice, sendErrorNotice, pad } from "@/commons/utils";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    props: ["customer_id"],
    data() {
        return {
            viewName: "container_list",
            dialogItem: false,
            pad: pad,
            service_group_list: configs.SERVICE_GROUP_LIST,
            headers: [{
                    text: "Mã đơn",
                    value: "id",
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Khách hàng",
                    value: "customer_first_name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tổng SP",
                    value: "number_of_product",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng sau giảm",
                    value: "amount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đã trả",
                    value: "paid",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "note",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Người tạo",
                    value: "created_by",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        customer_id() {
            if(this.customer_id) {
                this.filter_data();
            }
        },
        currentPath() {
            this.filter_data();
        }
    },
    computed: {
        ...mapState({
            items: state => state.receipts.all.data,
            total_rows: state => state.receipts.all.total,
            loading: state => state.receipts.loading,
            currentItem: (state) => state.receipts.selected
        }),
        adminRole() {
            return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
        },
        staffRole() {
            return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Staff;
        },
        currentPath() {
            return this.$route.path;
        },
    },
    methods: {
        add_date_range_filter() {
            if(this.filterConditions.length == 0) {
                let start_date = new URL(location.href).searchParams.get('start_date');
                let end_date = new URL(location.href).searchParams.get('end_date');
                if(start_date || end_date) {
                    _.remove(this.filterConditions, {'column': 'created_at'})
                }
                if(start_date) {
                    this.filterConditions.push({column: 'created_at', value: start_date, condition: "d_greater_than_or_equal"});
                }
                if(end_date) {
                    this.filterConditions.push({column: 'created_at', value: end_date, condition: "d_less_than_or_equal"});
                }
            }
        },
        filter_data: function () {
            this.add_date_range_filter();
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            if(this.customer_id) {
                param.filter.push({column: 'customer_id', value: this.customer_id, condition: "equal"});
            }
            this.$store.dispatch("receipts/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        editItem(id) {
            this.$router.push({
                name: "ExportOrderDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết đơn xuất (#${id})`
                }
            });
        },
        createData() {
            this.$router.push({
                name: "ExportOrderDetail",
                params: {
                Pid: 'tao-moi',
                title: `Tạo mới đơn xuất`
                }
            });
        },
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("receipts/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
